import { render, staticRenderFns } from "./lesson_create.vue?vue&type=template&id=32ab732c&scoped=true"
import script from "./lesson_create.vue?vue&type=script&lang=js"
export * from "./lesson_create.vue?vue&type=script&lang=js"
import style0 from "./lesson_create.vue?vue&type=style&index=0&id=32ab732c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab732c",
  null
  
)

export default component.exports